import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

const Span = /*#__PURE__*/styled.span.withConfig({
  displayName: "illustration__Span",
  componentId: "zettle__sc-1gpaqf6-0"
})([".illustration-class-primary{fill:#273664;}.illustration-class-secondary{fill:#cfdcf6;}.illustration-class-base{fill:#ffffff;}", ""], _ref => {
  let {
    width,
    height
  } = _ref;
  return `
      svg {
        width: ${width};
        height: ${height};
      }
    `;
});
const Illustration = _ref2 => {
  let {
    illustration,
    alt,
    width,
    height,
    ...props
  } = _ref2;
  return /*#__PURE__*/jsx(Span, {
    ...props,
    role: "img",
    "aria-label": alt,
    width: width,
    height: height,
    dangerouslySetInnerHTML: {
      __html: illustration.svg
    }
  });
};

export { Illustration };
//# sourceMappingURL=index.js.map
